import {date} from 'pm-utils';
const {dayjs} = date;
export default dayjs;